module.exports = __webpack_public_path__ + "static/media/whatsapp-logo-1.953a8c3e.png";